// GoatCounter analytics — privacy-first, no cookies, GDPR OK.
// Gộp instance với blog quoc.app + quiz oto.quoc.app (cùng quoc.goatcounter.com).
//
// PHÂN BIỆT CÁC SITE (đều trong 1 dashboard):
// - Blog quoc.app: path "/" (SDK auto)
// - Quiz oto.quoc.app: path "/quiz" (manual, no_onload)
// - Draw — Sketch and Share draw.quoc.app: path "/draw" (manual, no_onload) + biến thể share
//   → dashboard Pages hiện riêng từng site, không lẫn.
//
// BIẾN THỂ ROUTE DRAWLAB (SPA hash routing, pathname luôn "/"):
// - /draw            — mở app chính (editor)
// - /draw/share      — mở link share viewer (#share=)
// - /draw/share-pres — mở link share presentation (#share-pres=)
// - /draw/presentation — trình bày local (#presentation=)
//
// RACE CONDITION: script async. Queue + retry 1 lần nếu SDK chưa load.
// Silent fail mọi thứ — analytics không bao giờ break app.

declare global {
  interface Window {
    goatcounter?: {
      count: (params: {
        path: string;
        title?: string;
        event?: boolean;
        referrer?: string;
      }) => void;
    };
  }
}

const queue: Array<{ path: string; title?: string; event: boolean }> = [];

// Flush queue. Return true nếu SDK đã load + flush thành công.
function flush(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  if (!window.goatcounter) {
    return false;
  }
  while (queue.length > 0) {
    const { path, title, event } = queue.shift()!;
    try {
      window.goatcounter.count({ path, title, event });
    } catch {
      // SDK lỗi giữa chừng, bỏ hit đó
    }
  }
  return true;
}

// Track hit (pageview hoặc event). Queue + retry nếu SDK chưa load.
function track(path: string, title?: string, event = false) {
  try {
    queue.push({ path, title, event });
    if (!flush()) {
      setTimeout(flush, 1000); // SDK chưa load, retry sau 1s
    }
  } catch {
    // analytics không bao giờ break app
  }
}

// Manual pageview theo route DrawLab.
// Gọi 1 lần khi route render. Path riêng để dashboard phân biệt site.
export function trackPageview(path: string, title: string) {
  track(path, title);
}

// Event khi user tạo share link (biết traffic share thật, không chỉ mở link).
export function trackShareCreated(hasFrames: boolean) {
  track(
    hasFrames ? "share-created-pres" : "share-created",
    hasFrames ? "Tạo share presentation" : "Tạo share viewer",
    true,
  );
}

export {};
